import { subscriptionState, SUBSCRIPTION_WARNING_DAYS } from "@/utils/plans";
import { plural } from "@/utils/format";

/**
 * Rappel de fin d'abonnement : 30 jours avant l'échéance, puis consultation seule une fois échu (le
 * serveur refuse alors toute écriture).
 */
export default function SubscriptionBanner({
  endsAt,
}: {
  endsAt: string | null;
}) {
  const { expired, daysLeft } = subscriptionState(endsAt);
  if (
    !endsAt ||
    daysLeft === null ||
    (!expired && daysLeft > SUBSCRIPTION_WARNING_DAYS)
  )
    return null;
  const date = new Date(`${endsAt}T00:00:00`).toLocaleDateString("fr-FR");
  return (
    <div
      role="status"
      className={`mb-4 flex items-start gap-3 rounded-lg border px-4 py-3 text-sm ${
        expired
          ? "border-accent-200 bg-accent-50 text-accent-800"
          : "border-warning-200 bg-warning-50 text-warning-800"
      }`}
    >
      <i
        className={`${expired ? "ri-lock-line" : "ri-time-line"} mt-0.5 text-base`}
        aria-hidden="true"
      ></i>
      <p>
        {expired ? (
          <>
            <strong>L'abonnement de l'école a pris fin le {date}.</strong> Vous
            pouvez consulter et imprimer, mais plus rien enregistrer. Contactez
            WaitechEdu pour le renouveler.
          </>
        ) : (
          <>
            <strong>
              L'abonnement de l'école prend fin le {date}
              {daysLeft === 0
                ? " (aujourd'hui)"
                : ` (dans ${plural(daysLeft, "jour")})`}
              .
            </strong>{" "}
            Pensez à le renouveler auprès de WaitechEdu pour continuer à tout
            enregistrer.
          </>
        )}
      </p>
    </div>
  );
}
